import styled from 'styled-components';

export const LocationContainer = styled.div`

`;

export const RowJustifyContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;